import React from 'react';
import { FormikProps } from 'formik';
import { Form, Card, CardHeader, CardBody } from 'reactstrap';
import { range } from 'lodash';

import { SaveButton } from 'components';
import { ISettings } from 'types';

import {
  FeaturesCard,
  NumberSelect,
  PaymentsCard,
  StatusCard,
  SystemMessageCard,
} from './components';

export const SettingsForm = (props: ISettings & FormikProps<ISettings>) => {
  const {
    handleSubmit,
    isSubmitting,
    setFieldValue,
    handleChange,
    systemMessageOn,
    values: { status, features, cache, payments, systemMaintenance },
  } = props;

  return (
    <Form>
      <StatusCard handleChange={handleChange} status={status} />

      <SystemMessageCard
        handleChange={handleChange}
        systemMaintenance={systemMaintenance}
        setFieldValue={setFieldValue}
        systemMessageOn={systemMessageOn}
      />

      <FeaturesCard handleChange={handleChange} features={features} setFieldValue={setFieldValue} />

      <Card className="mb-3">
        <CardHeader tag="h5">Cache</CardHeader>
        <CardBody>
          <NumberSelect
            value={cache.defaultShardCacheTimeInMinutes}
            field="cache.defaultShardCacheTimeInMinutes"
            onChange={props.handleChange}
            options={range(0, 3800, 200)}
          />
        </CardBody>
      </Card>

      <PaymentsCard handleChange={handleChange} payments={payments} />
      <SaveButton disabled={isSubmitting} onSubmit={() => handleSubmit()} text={isSubmitting ? 'Saving...' : 'Save'} />
    </Form>
  );
};
